<main>
    <router-outlet></router-outlet>
</main>
<footer class="footer footer-dark-blue">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="text-center wrap-widget">
                    <p class="copyright-text">® 2020 ProfeJOBS. Todos los derechos reservados.</p>
                </div>
            </div>
        </div>
    </div>
</footer>